import $http from '@/api/index'
import { getToken } from '../../../util/auth'
const cookieUser = getToken()
//获取配置参数
export function getConfig(configCode) {
  let getUrl = {
    method: 'GET',
    url: 'DMS/GetConfig',
    requestType: 2
  }
  let params = {
    config: configCode
  }
  return $http(getUrl, params)
}

export function UpdateConfig(code, config) {
  let getUrl = {
    method: 'POST',
    url: 'DMS/UpdateConfig',
    requestType: 2
  }
  let params = {
    Code:code,
    Config:config
  }
  return $http(getUrl, params)
}

///获取二维码
export function getQRcode(content, width, height) {
  let getUrl = {
    method: 'POST',
    url: 'basedata/ComposeQRcode',
    requestType: 2
  }
  let params = {
    Content: content,
    Width: width,
    Height: height
  }
  return $http(getUrl, params)
}

///设置配置参数
export function setConfig(noteName, paramStr, paramType) {
  let getUrl = {
    method: 'POST',
    url:
      'DMS/SetConfig?userId=' +
      cookieUser.userId +
      '&deptId=' +
      cookieUser.departmentId +
      '&noteName=' +
      noteName +
      '&paramsStr=' +
      paramStr +
      '&paramType=' +
      paramType,
    requestType: 2
  }
  let params = {
    // userId:cookieUser.userId,deptId:cookieUser.departmentId,
    // noteName:noteName, paramsStr:paramStr, paramType:paramType
  }
  return $http(getUrl, params)
}

//获取设置的模板集合
export function getAllSelectedParamsConfigs(paramType) {
  let getUrl = {
    method: 'GET',
    url:
      'task/GetAllSelectedParamsConfigs?userId=' +
      cookieUser.userId +
      '&deptId=' +
      cookieUser.departmentId +
      '&paramType=' +
      paramType,
    requestType: 2
  }
  let params = {
    // userId:cookieUser.userId,deptId:cookieUser.deptId,paramType:paramType
  }
  return $http(getUrl, params)
}
//获取通用ID
export function GetCode(tableName, columnName = 'ID') {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetCode',
    requestType: 2
  }
  let params = {
    tableName: tableName,
    columnName: columnName
  }
  return $http(getUrl, params)
}

///数据遍历成树
export function listToTree(myId, pId, list) {
  const dic = new Map()
  const dic_1 = new Map()
  var len = list.length
  for (var i = 0; i < len; i++) {
    dic.set(list[i][myId], list[i])
    if (dic_1.has(list[i][pId])) {
      dic_1.get(list[i][pId]).push(list[i])
    } else {
      dic_1.set(list[i][pId], [list[i]])
    }
  }
  var nodes = []
  for (var i = 0; i < len; i++) {
    if (!dic.has(list[i][pId])) {
      nodes.push(list[i]) //根节点
    }
  }
  var toDo = []
  var len_1 = nodes.length
  for (var i = 0; i < len_1; i++) {
    toDo.push(nodes[i])
  }
  while (toDo.length) {
    var node = toDo.shift() // the parent node
    if (dic_1.has(node[myId])) {
      var ls = dic_1.get(node[myId])
      node.children = ls //dic_1.get(node[myId]);
      for (var j = 0; j < ls.length; j++) toDo.push(ls[j])
    }
  }
  return nodes //树形菜单
}
///数据遍历成树
export function listToTrees(myId, pId, list) {
  const dic = new Map()
  const dic_1 = new Map()
  var len = list.length
  for (var i = 0; i < len; i++) {
    dic.set(list[i][myId], list[i])
    if (dic_1.has(list[i][pId])) {
      dic_1.get(list[i][pId]).push(list[i])
    } else {
      dic_1.set(list[i][pId], [list[i]])
    }
  }
  var nodes = []
  for (var i = 0; i < len; i++) {
    if (!dic.has(list[i][pId])) {
      nodes.push(list[i]) //根节点
    }
  }
  var toDo = []
  var len_1 = nodes.length
  for (var i = 0; i < len_1; i++) {
    toDo.push(nodes[i])
  }
  while (toDo.length) {
    var node = toDo.shift() // the parent node
    if (dic_1.has(node[myId])) {
      var ls = dic_1.get(node[myId])
      node.childrens = ls //dic_1.get(node[myId]);
      for (var j = 0; j < ls.length; j++) toDo.push(ls[j])
    }
  }
  return nodes //树形菜单
}

/**
 * 树形数据的搜索方法(获取查询值)
 * @param {*} tree 树结构数据
 * @param {*} id 找到的ID值
 */
export function breadthQuery(tree, id) {
  var stark = []

  stark = stark.concat(tree)

  while (stark.length) {
    var temp = stark.shift()
    if (temp.children) {
      stark = stark.concat(temp.children)
    }
    if (temp.ID === id) {
      return temp
    }
  }
}

/**
 * 树形数据的搜索方法(获取查询值)
 * @param {*} tree 树结构数据
 * @param {*} id 找到的ID字段
 */
export function AllChildNode(tree, id) {
  var stark = []
  let arrRes=[]
  stark = stark.concat(tree)

  while (stark.length) {
    var temp = stark.shift()
    console.log(temp,'temp')
    if (temp.childrens) {
      stark = stark.concat(temp.childrens)
    }
      arrRes.push(temp[id])
  }
  return arrRes;
}

/**
 * 递归树结构数据查找所有父级
 * @param {*} tree 树结构数据
 * @param {*} id 找到的ID值
 */
export function getParent(tree, id) {
  var arrRes = []
  if (tree.length == 0) {
    if (!!id) {
      arrRes.unshift(tree)
    }
    return arrRes
  }
  let rev = (data, nodeId) => {
    for (var i = 0, length = data.length; i < length; i++) {
      let node = data[i]
      if (node.ID == nodeId) {
        arrRes.unshift(node)
        rev(tree, node.PARENTID)
        break
      } else {
        if (!!node.children) {
          rev(node.children, nodeId)
        }
      }
    }
    return arrRes
  }
  arrRes = rev(tree, id)
  return arrRes
}

/**
 * 递归树结构数据查找所有父级
 * @param {*} tree 树结构数据
 * @param {*} id 找到的ID值
 */
export function getParents(tree, id) {
  var arrRes = []
  if (tree.length == 0) {
    if (!!id) {
      arrRes.unshift(tree)
    }
    return arrRes
  }
  let rev = (data, nodeId) => {
    for (var i = 0, length = data.length; i < length; i++) {
      let node = data[i]
      if (node.ID == nodeId) {
        arrRes.unshift(node)
        rev(tree, node.PARENTID)
        break
      } else {
        if (!!node.childrens) {
          rev(node.childrens, nodeId)
        }
      }
    }
    return arrRes
  }
  arrRes = rev(tree, id)
  return arrRes
}

//在线预览下载功能
export function Download2(filePath) {
  let getUrl = {
    method: 'GET',
    url: 'file/Download2',
    requestType: 4
  }
  let params = {
    filePath: filePath
  }
  return $http(getUrl, params)
}

//TODO: 根据文件名获取视频地址
export function GetVideoPlayAddress(filename, caption) {
  let getUrl = {
    method: 'GET',
    url: 'video/VideoPlayAddress',
    requestType: 5
  }
  let params = {
    filename: filename,
    caption: caption
  }
  return $http(getUrl, params)
}
/*
 * 根据搜索条件搜索故障类型,模板基础控件使用
 */
export function GetTemplateFaultTypeSearchResult(params) {
	let options = {
		method: 'POST',
		url: 'basedata/GetTemplateFaultTypeSearchResult',
		requestType: 2
	}
	return $http(options, params)
}

/*
 * 根据搜索条件搜索故障类型,模板基础控件使用
 */
export function GetTemplateFaultTypeSearchResultByTemplateID(templateId) {
	let options = {
		method: 'POST',
		url: 'basedata/GetTemplateFaultTypeSearchResultByTemplateID?templateId='+templateId,
		requestType: 2
	}
	let params={
		// templateId:templateId,
	}
	return $http(options, params)
}
/**
 * 获取系统或者个人的常用故障类型所涉及的运维对象分类。 存在个人的则返回个人，不存在个人则返回系统。
 */
export function GetSystemOrPersonalDefaultFaultTypeResult(userId) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetSystemOrPersonalDefaultFaultTypeResult',
    requestType: 2
  }
  let params = {
    userId: userId
  }
  return $http(getUrl, params)
}
/**
 * 获取系统或者个人的常用故障类型所涉及的运维对象分类。 存在个人的则返回个人，不存在个人则返回系统。
 */
export function UpdateCommonObjTypeBSMVInstance(Para) {
  let getUrl = {
    method: 'POST',
    url: 'basedata/UpdateCommonObjTypeBSMVInstance',
    requestType: 2
  }
  // let params = {
  //   listId: listId,
  //   userId:userId,
  //   systemOrPersonal:systemOrPersonal
  // }
  return $http(getUrl, Para)
}
/**
 * 新增打回事件原因（type=1， 0是故障类型）
 */
export function AddorUpdateEventReason(obj) {
  let getUrl = {
    method: 'POST',
    url: 'task/AddorUpdateEventReason',
    requestType: 2
  }
  return $http(getUrl, obj)
}
/**
 * 新增打回事件原因（type=1， 0是故障类型）
 */
export function DeleteEventReason(ID) {
  let getUrl = {
    method: 'GET',
    url: 'task/DeleteEventReason',
    requestType: 2
  }
  let params = {
    ID: ID,
  }
  return $http(getUrl, params)
}
/**
 * 修改是否启用故障类型
 */
export function UpdateEventRessonEnable(ID,IsEnable) {
  let getUrl = {
    method: 'GET',
    url: 'task/UpdateEventRessonEnable?ID='+ID+"&IsEnable="+IsEnable,
    requestType: 2
  }
  let params = {

  }
  return $http(getUrl, params)
}

/**
 * 更新系统或者个人的常用故障类型所涉及的运维对象分类,userId 为空或者null,表示系统
 */
export function UpdateSystemOrPersonalCommonFaultTypeObj(userId,objId,state,type) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/UpdateSystemOrPersonalCommonFaultTypeObj?userId='+userId+"&objId="+objId+"&state="+state+"&type="+type,
    requestType: 2
  }
  let params = {
    // userId:userId,
    // objId:objId,
    // state:state,
  }
  return $http(getUrl, params)
}

/**
 * 判断当前用户是否本机构管理岗或者是super用户
 * @param {*} userId
 */
export function IsSelfManagerPostUser(userId) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/IsSelfManagerPostUser',
    requestType: 2
  }
  let params = {
    userId:userId,
  }
  return $http(getUrl, params)
}
/**
 * 判断当前用户是否本机构管理岗或者是super用户
 * @param {*} objId
 * @param {*} userId
 */
export function GetEventReasonByObjIdAndUserId(objId,userId) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetEventReasonByObjIdAndUserId?objId='+objId+'&userId='+userId,
    requestType: 2
  }
  let params = {
  }
  return $http(getUrl, params)
}
/**
 * 重新排序常用故障类型，或者常用的故障类型涉及的运维对象， type = 0表示运维对象  1：表示故障类型listSocialId :排序后的故障类型ID，或者运维对象ID，
 */
export function ResortFaultTypeObjOrderIndex(listSocialId,userId,type) {
  let getUrl = {
    method: 'POST',
    url: 'basedata/ResortFaultTypeObjOrderIndex',
    requestType: 2
  }
  let params = {
    listSocialId:listSocialId,
    userId:userId,
    type:type
  }
  return $http(getUrl, params)
}
export function GetUserByID(ID){
	let getUrl = {
	    method: 'GET',
	    url: 'user/GetUserByID',
	    requestType: 2
	};
	let params = {
	    userID: ID,
	};
	return $http(getUrl, params);
}
//获取管理员账号
export function GetConfig(config){
	let getUrl = {
	    method: 'GET',
	    url: 'DMS/GetConfig',
	    requestType: 2
	};
	let params = {
	    config: config,
	};
	return $http(getUrl, params);
}
//根据服务台Id获取指定人员(0运维，1客服)
export function GetSysUserByServerId(serverId,type){
	let getUrl = {
	    method: 'GET',
	    url: 'ServerDuty/GetSysUserByServerId',
	    requestType: 2
	};
	let params = {
     serverId: serverId,
     type:type
	};
	return $http(getUrl, params);
}

